import {
  PaymentStatus,
  TaxItemOrder,
} from '@/api/ariadne/__generated_types__/apollo';
import { dayjs } from '@/utils/dayjs';
import {
  AG_GRID_COLORED_CELL_COLOR_PALETTE,
  IColorPalette,
} from 'deckard-ui/dist/components/AGGridTable/cell-renderers/colored-cell/color-palette';
import { SortMappings, SortMode } from './types';

export const EARLIEST_SELECTABLE_MONTH = dayjs('2017-01-01');

export enum TOP_LEVEL_TOT_TEST_IDS {
  // Actions
  ACTIONS_CONTAINER = 'tlt-actions-container',
  DOWNLOAD_BUTTON = 'tlt-download-button',

  // Summary
  SUMMARY = 'tlt-summary',
  SUMMARY_TOTAL_TAX_PAID_FOR_PERIOD = 'tlt-summary-total-tax-paid-for-period',
  SUMMARY_NUMBER_PAID_FOR_PERIOD = 'tlt-summary-number-paid-for-period',
  SUMMARY_PENALTIES_AND_INTEREST_PAID_FOR_PERIOD = 'tlt-summary-penalties-and-interest-paid-for-period',
  SUMMARY_EXPECTED_TAX_TO_BE_PAID_FOR_PERIOD = 'tlt-summary-expected-tax-to-be-paid-for-period',
  SUMMARY_NUMBER_YET_TO_REPORT = 'tlt-summary-number-yet-to-report',
  SUMMARY_PERCENTAGE_LATE_PAYMENTS = 'tlt-summary-percentage-late-payments',

  // Table Controls
  PAYMENT_PERIOD_SEARCH = 'tlt-payment-period-search',
  PAYMENT_PERIOD_DROPDOWN = 'tlt-payment-period-dropdown',
  PAYMENT_PERIOD_TAX_STATUS_DROPDOWN = 'tlt-payment-period-tax-status-dropdown',
  PAYMENT_PERIOD_ADDITIONAL_FILTERS = 'tlt-payment-period-additional-filters',
  PAYMENT_PERIOD_ADDITIONAL_FILTERS_POPUP = 'tlt-payment-period-additional-filters-popup',
}

export const PAYMENT_STATUS_TO_USER_STRING_MAP: Record<PaymentStatus, string> =
  {
    [PaymentStatus.Unreported]: 'Unreported',
    [PaymentStatus.Issue]: 'Issue',
    [PaymentStatus.Overdue]: 'Overdue',
    [PaymentStatus.Paid]: 'Paid',
    [PaymentStatus.Pending]: 'Pending',
  };

export const uiSortModeToAriadneSortMode: Record<SortMode, TaxItemOrder> = {
  ADDRESS_ASC: TaxItemOrder.AddressAsc,
  ADDRESS_DESC: TaxItemOrder.AddressDesc,
  APN_ASC: TaxItemOrder.ApnAsc,
  APN_DESC: TaxItemOrder.ApnDesc,
  SUBMISSION_DATE_ASC: TaxItemOrder.SubmissionDateAsc,
  SUBMISSION_DATE_DESC: TaxItemOrder.SubmissionDateDesc,
};

export const TAX_ITEMS_SORT_MAPPINGS: SortMappings = {
  'property.address': {
    asc: 'ADDRESS_ASC',
    desc: 'ADDRESS_DESC',
  },
  'property.apn': {
    asc: 'APN_ASC',
    desc: 'APN_DESC',
  },
  'taxPayments.paymentSubmissionDate': {
    asc: 'SUBMISSION_DATE_ASC',
    desc: 'SUBMISSION_DATE_DESC',
  },
};

export const TAX_STATUS_SELECTOR_OPTIONS: {
  label: string;
  value: PaymentStatus;
}[] = Object.values(PaymentStatus).map((value: PaymentStatus) => ({
  label: String(PAYMENT_STATUS_TO_USER_STRING_MAP[value]),
  value,
}));

export const TOP_LEVEL_TOT_VIEW_STATUS_COLOR_PALETTE_MAP: Record<
  PaymentStatus,
  IColorPalette
> = {
  [PaymentStatus.Unreported]: AG_GRID_COLORED_CELL_COLOR_PALETTE.LIGHT_BLUE,
  [PaymentStatus.Issue]: AG_GRID_COLORED_CELL_COLOR_PALETTE.RED,
  [PaymentStatus.Overdue]: AG_GRID_COLORED_CELL_COLOR_PALETTE.DARK_GREY,
  [PaymentStatus.Paid]: AG_GRID_COLORED_CELL_COLOR_PALETTE.GREEN,
  [PaymentStatus.Pending]: AG_GRID_COLORED_CELL_COLOR_PALETTE.BLACK,
};
